import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    label: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Label for inviting a new user */
            label: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "PendingMemberAccessRow.label?c=2fbsn20nhlayk", defaultMessage: "Invite new user" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
